<ng-container *ngIf="!isUpdateInProgress">

  <ng-container *ngIf="isMultiselectMode || isRoot() || isFolder(); else byObjectType">

    <ng-container *ngIf="isMultiselectMode">
      <mee-multiselect-configuration
        #multiselect
        [node]="node"
        [companySlug]="companySlug"
        [sourceType]="sourceType"
        (updateLayerGroup)="updateLayerGroup"
        [layers]="layers"></mee-multiselect-configuration>
    </ng-container>

    <ng-container *ngIf="isRoot() && !isMultiselectMode">
      <mee-root-configuration
        #root
        [node]="node"
        [companySlug]="companySlug"
        [dataSourceSettings]="dataSourceSettings"
        [sourceType]="sourceType"
        [isSourceRealTime]="isSourceRealTime"
        (updateLayerGroup)="updateLayerGroup()"
        [layers]="layers"></mee-root-configuration>
    </ng-container>

    <ng-container *ngIf="isFolder() && !isMultiselectMode">
      <mee-folder-configuration
        #folder
        [node]="node"
        [sourceType]="sourceType"
        [layers]="layers"
        (updateLayerGroup)="updateLayerGroup()"
      ></mee-folder-configuration>
    </ng-container>

  </ng-container>

  <ng-template #byObjectType>
    <ng-container *ngIf="isPoint()">
      <mee-point-configuration
        #point
        [node]="node"
        [sourceType]="sourceType"
        [layers]="layers"
        [placeMarksFields]="placeMarksFields"
        (updateLayerGroup)="updateLayerGroup()"
      ></mee-point-configuration>
    </ng-container>

    <ng-container *ngIf="isLine()">
      <mee-line-configuration
        #line
        [node]="node"
        [sourceType]="sourceType"
        [layers]="layers"
        [placeMarksFields]="placeMarksFields"
        (updateLayerGroup)="updateLayerGroup()"
      ></mee-line-configuration>
    </ng-container>

    <ng-container *ngIf="isArea()">
      <mee-area-configuration
        #area
        [node]="node"
        [sourceType]="sourceType"
        [layers]="layers"
        [placeMarksFields]="placeMarksFields"
        (updateLayerGroup)="updateLayerGroup()"
      ></mee-area-configuration>
    </ng-container>

    <ng-container *ngIf="isModel3D()">
      <mee-model3d-configuration
        #model3D
        [node]="node"
        [sourceType]="sourceType"
        [layers]="layers"
        [isModelLevel]="isModelLevel"
        [companySlug]="companySlug"
        [customCoordinateSystems]="coordinateSystems"
        [placeMarksFields]="placeMarksFields"
        (updateLayerGroup)="updateLayerGroup()"
      ></mee-model3d-configuration>
    </ng-container>

    <ng-container *ngIf="isUnknown()">
      <mee-unknown-configuration
        #unknown
        [node]="node"
        [sourceType]="sourceType"
        [layers]="layers"
        [placeMarksFields]="placeMarksFields"
        (updateLayerGroup)="updateLayerGroup()"
      ></mee-unknown-configuration>
    </ng-container>
  </ng-template>
</ng-container>

<div class="loader-wrapper" *ngIf="isUpdateInProgress">
  <div class="loader"></div>
</div>




